export interface CpaParticipants {
  includedCount: number;
  totalCount: number;
  participants: [
    {
      overview: string;
      address: {
        zip: string;
        address2: string;
        city: string;
        addressType: string;
        address1: string;
        state: string;
        id: number;
      };
      endDate: string;
      gln: string;
      active: boolean;
      hasFacilities: boolean;
      participant: boolean;
      organizationType: string;
      participantId: number;
      agreementTerm: {
        duration: number;
        targetMarketShare: number;
        pricingType: any;
      };
      name: string;
      potentialSavings: number;
      actualSpend: number;
      continuedSpend: number;
      id: number;
      hasSpend: boolean;
      startDate: string;
      memberId: string;
      parents: [
        {
          level: number;
          name: string;
          id: number;
        }
      ];
    }
  ];
}

export default class CpasService {
  static $inject = ['$http'];

  baseUrl = '/aptitude/api/cpas';

  constructor(private $http) {
    'ngInject';
  }

  createContract(offerId: number) {
    return this.$http.post(`${this.baseUrl}`, {
      offerId
    });
  }

  getContract(cpaId: number) {
    return this.$http.get(`${this.baseUrl}/${cpaId}`);
  }

  getParticipants(cpaId: number): ng.IPromise<CpaParticipants> {
    return this.$http.get(`${this.baseUrl}/${cpaId}/participants`);
  }

  getSigningUrl(cpaId: number) {
    return this.$http
      .get(`${this.baseUrl}/${cpaId}/signingurl`)
      .then((value) => {
        return value.signingUrl;
      });
  }

  sendContract(offerId: number, userId: number, message: string) {
    return this.$http.post(
      `/aptitude/buyer/ContractingServiceController/requestNewSigner`,
      {
        responseId: offerId,
        userId,
        message
      }
    );
  }

  updateTerms(cpaId: number) {
    return this.$http.put(`/aptitude/api/cpas/${cpaId}/cpaterms`, {});
  }
}
